<select v-model="language" v-if="languages.length"><option v-for="item in languages" :value="item.code">{{ item.label }}</option></select>